import { SignInSource } from '../constants';

export const IsSwitchToOldExperienceAvailable = (signInSource: string) => {
	if (
		signInSource === SignInSource.ClientMobileApp ||
		signInSource === SignInSource.ClientPortal
	) {
		return false;
	}
	return true;
};
